export function getRoutes(baseURL: string) {
  return {
    BASE: baseURL,
    COCKPIT: "https://www.cockpit.com.br/",
    LOGIN: `${baseURL}/login`,
    REGISTER: `${baseURL}/register`,
    WM_APP_DOWNLOAD: "https://app.adjust.com/rfifsh8",
    SUBSCRIPTION: `${baseURL}/assinar-carro`,
    GARAGE: {
      BASE: `${baseURL}/garagem`,
      PERFIL: `${baseURL}/garagem/perfil`,
      PRODUCTS: `${baseURL}/garagem/produtos`,
      FAVORITES: `${baseURL}/garagem/favoritos`,
      PROPOSALS: `${baseURL}/garagem/propostas`,
    },
    INSTITUTIONAL: {
      ALO_ETICA:
        "https://aloetica.com.br/otrs/canal-de-etica.pl?CustomerID=webmotors.com.br",
      CONDUCT_CODE:
        "https://webmotors.com.br/seguranca/assets/files/codigo-de-conduta.pdf",
      SUPPLIER_CONDUCT_CODE:
        "https://webmotors.com.br/seguranca/assets/files/codigo-conduta-fornecedores.pdf",
      CONSUMER:
        "https://cdn.webmotors.com.br/webmotors/content/pdf/cdc.pdf?v:32673",
      PRIVACY: "https://webmotors.com.br/seguranca/politica-de-privacidade",
      LGPD: "https://webmotors.com.br/seguranca/lgpd",
      LGPD_BOOK:
        "https://www.webmotors.com.br/seguranca/assets/files/cartilha_lgpd_webmotors.pdf",
      TRANSPARENCY:
        "https://webmotors.com.br/seguranca/assets/files/relat%C3%B3rio_de_transpar%C3%AAncia_da_portaria_mte_no_3.714.2023.pdf",
      COOKIE_POLICY:
        "https://www.webmotors.com.br/assets/politica-de-cookies.pdf",
    },
    SERVICES: {
      SERVICES: `${baseURL}/servicos-automotivos/home/`,
      FIPE: `${baseURL}/tabela-fipe`,
      FAZTUDO: `${baseURL}/vender-carro/faztudo`,
      FINANCING: `${baseURL}/financiamento`,
      CONSORTIUM: `${baseURL}/solutions/consorcio`,
      DEALER_PLATFORM: "https://cockpit.com.br/",
      INSURANCE: "https://www.autocompara.com.br/",
      CAR10: `${baseURL}/car10`,
      AUTOPAGO: "https://autopago.webmotors.com.br/",
      AUTOINSIGHTS: "https://publicidade.webmotors.com.br/tag/blog/index.html",
      ADVERTISING: "https://publicidade.webmotors.com.br",
      COMPARE_VEHICLES: `${baseURL}/catalogo/comparativo-de-carros`,
      FINES_AND_DEBTS:
        "https://www.webmotors.com.br/servicos-automotivos/debitos-veiculares",
      CERTIFIED_PURCHASE: `${baseURL}/compracertificada`,
      CONSORCIO: `${baseURL}/consorcio`,
    },
    HELP: {
      YOU: "https://ajuda.webmotors.com.br/hc/pt-br",
      HOW_TO_BUY: "https://ajuda.cockpit.com.br/hc/pt-br/",
      HOW_TO_SELL:
        "https://ajuda.webmotors.com.br/hc/pt-br/articles/360038764251-como-anunciar-/",
      STORE: "https://ajuda.cockpit.com.br/hc/pt-br",
      SECURITY: `${baseURL}/solutions/seguranca`,
      PRIVACY_POLICY: `${baseURL}/assets/termos-de-uso-e-politica-de-privacidade.pdf`,
      INSTITUCIONAL: "https://www.webmotors.com.br/solutions/quemsomos",
      WORK_WITH_US: "https://webmotors.gupy.io/",
      SITEMAP: `${baseURL}/mapasite`,
    },
    WM1: {
      PORTAL: `${baseURL}/wm1`,
      LASTNEWS: `${baseURL}/wm1/noticias`,
      TESTS: `${baseURL}/wm1/testes`,
      COMPARATIVES: `${baseURL}/wm1/comparativos`,
      VIDEOS: `${baseURL}/wm1/videos-de-carros-e-motos`,
      BIKES: `${baseURL}/wm1/motos`,
      SECRETS: `${baseURL}/wm1/segredos-auto`,
      TIPS: `${baseURL}/wm1/dicas`,
      POCKET: `${baseURL}/wm1/dinheiro-e-economia`,
    },
    CAR: {
      ALL: `${baseURL}/carros/estoque`,
      NEW: `${baseURL}/carros-novos/estoque`,
      USED: `${baseURL}/carros-usados/estoque`,
      BY_STATE: `${baseURL}/mapasite/carros`,
      ZERO: `${baseURL}/catalogo`,
      SELL: `${baseURL}/vender-carro`,
    },
    BIKE: {
      NEW: `${baseURL}/motos-novas/estoque`,
      USED: `${baseURL}/motos-usadas/estoque`,
      BY_STATE: `${baseURL}/mapasite/motos`,
      SELL: `${baseURL}/vender-moto`,
    },
    SOCIAL: {
      INSTAGRAM: "https://www.instagram.com/webmotors",
      FACEBOOK: "https://www.facebook.com/webmotors",
      YOUTUBE: "https://www.youtube.com/@webmotors",
      LINKEDIN: "https://www.linkedin.com/company/webmotors",
      X: "https://x.com/webmotors",
      TIKTOK: "https://www.tiktok.com/@webmotors",
    },
  };
}
